module.exports = __webpack_public_path__ + "static/templates/bulk-upload-v2-vi.1a-QTxI.xlsx";